import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from './locales/ar.json';
import en from './locales/en.json';
import { Provider } from 'react-redux';
import { store } from './redux/store';

// Arabic is the default. English stays available through the switcher, but a
// browser set to English must not decide it — that used to drop visitors into
// the English bundle on their first visit.
const SUPPORTED = ["ar", "en"];
const saved = localStorage.getItem("i18nextLng");
const startLang = SUPPORTED.includes(saved) ? saved : "ar";
localStorage.setItem("i18nextLng", startLang);

// bundled, not fetched: a fetched translation.json is cached by the browser
// independently of the JS bundle, so newly added keys used to render as raw
// key names until a hard refresh. Bundling ties them to the bundle hash.
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    supportedLngs: SUPPORTED,
    lng: startLang,
    fallbackLng: "ar",
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
  });

const applyDirection = (lang) => {
  document.documentElement.setAttribute("lang", lang);
  document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
};
applyDirection(startLang);
i18n.on("languageChanged", applyDirection);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
